import React from "react";
import { PurchaseForm } from "./PurchaseForm";

const SAPPurchaseOrder =()=>{
    return(
        <>
       <PurchaseForm/>
        </>
    )
};

export default SAPPurchaseOrder;